import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(source, true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source)).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import Types from 'prop-types';
import { styled, StyleSheet } from '@rexlabs/styling';
import mixins from '../../utils/style-mixins';
import { ComponentPropType } from '../../utils/custom-prop-types';

var ChevronDownIcon = function ChevronDownIcon(props) {
  return React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16"
  }), React.createElement("path", {
    d: "M15.3 5.7l-6.9 6.9c-.1.1-.3.2-.4.2s-.3-.1-.4-.2L.7 5.7c-.1-.1-.2-.2-.2-.4s.1-.3.2-.4l1.5-1.5c.1-.1.3-.2.4-.2s.3.1.4.2l5 4.9 4.9-4.9c.1-.1.3-.2.4-.2.2 0 .3.1.4.2l1.5 1.5c.1.1.2.3.2.4.1.2 0 .3-.1.4z"
  }));
};

var DropdownButton = (_dec = styled(StyleSheet({
  container: _objectSpread({}, mixins.clickStyles, {}, mixins.suffixElements),
  disabled: _objectSpread({}, mixins.disabledClickStyles),
  isActive: {
    display: 'inline-block',
    transform: 'rotate(180deg)'
  },
  icon: _objectSpread({}, mixins.iconSize)
})), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(DropdownButton, _Component);

  function DropdownButton() {
    _classCallCheck(this, DropdownButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(DropdownButton).apply(this, arguments));
  }

  _createClass(DropdownButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          styles = _this$props.styles,
          isActive = _this$props.isActive,
          disabled = _this$props.disabled,
          Icon = _this$props.Icon,
          props = _objectWithoutProperties(_this$props, ["styles", "isActive", "disabled", "Icon"]);

      return React.createElement("span", _extends({
        title: isActive ? 'Show menu...' : 'Close menu...'
      }, props, styles.with('container', {
        disabled: disabled
      })(props)), React.createElement(Icon, styles('icon', {
        isActive: isActive
      })));
    }
  }]);

  return DropdownButton;
}(Component), _defineProperty(_class2, "propTypes", {
  styles: Types.func,
  Icon: ComponentPropType,
  isActive: Types.bool,
  disabled: Types.bool
}), _defineProperty(_class2, "defaultProps", {
  style: {},
  Icon: ChevronDownIcon
}), _temp)) || _class);
export default DropdownButton;